import { Link } from 'react-router-dom';
import { trendingCards } from '@/mocks/homeData';

export default function FeatureGrid() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              实时热度
              <span className="text-primary-500 ml-2">排行榜</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最热的吃瓜内容，实时更新</p>
          </div>
          <span className="hidden sm:inline-flex px-3 py-1.5 text-xs bg-foreground-900 text-background-50 rounded-full whitespace-nowrap">
            实时更新
          </span>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 snap-x">
          {trendingCards.map((card) => (
            <Link
              key={card.id}
              to="/"
              className="flex-shrink-0 w-[240px] md:w-[280px] snap-start group cursor-pointer"
            >
              <div className="bg-background-50 rounded-xl overflow-hidden">
                <div className="relative w-full aspect-square overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    title={`${card.title} - 51吃瓜app`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4">
                  <p className="text-xs text-foreground-500 line-clamp-1 mb-1">{card.subtitle}</p>
                  <p className="text-sm font-medium text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </p>
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-fire-fill text-accent-500 text-xs"></i>
                    </div>
                    <span className="text-lg font-bold text-foreground-900">
                      {(card.hotScore / 10000).toFixed(1)}万
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
          <div className="flex-shrink-0 w-8"></div>
        </div>
      </div>
    </section>
  );
}